////*** Import React Library
//import React, { useEffect, useState } from "react";
//import DataTable from "react-data-table-component";
//import Modal from 'react-bootstrap/Modal';
//import Axios from 'axios'
//import "../../Assets/Styles/robot.css";
//import { hasJWTToken } from "../Account/RouteGuard";
//import "../../Assets/Styles/Form.css";
//import * as FaIcons from "react-icons/fa";
//import AxiosInstance from '../Axios/AxiosInstance';
//const editRobot = (robotId) => {
//    sessionStorage.removeItem("editRobotId");
//    sessionStorage.setItem("editRobotId", robotId);
//    window.location.href = "#/EditRobot?rbtid=" + robotId + "";
//};
////*** Create custom style for react table
//const customStyles = {
//    table: {
//        style: {
//            border: "none",
//            fontSize: "100%"
//        },
//    },
//    header: {
//        backgroundColor: "transparent",
//    },
//    rows: {
//        style: {
//            backgroundColor: "transparent",
//        },
//    },
//    headRow: {
//        style: {
//            backgroundColor: "transparent",
//            fontSize: "110%"
//        },
//    },
//    pagination: {
//        style: {
//            backgroundColor: "transparent",
//            fontWeight: "600",
//        },
//    },
//    headCells: {
//        style: {
//            borderBottom: "none",
//            fontWeight: "700",
//            fontSize: "110%"
//        },
//    },
//};
//export const SearchRobot = () => {
//    const [searchTerm, setSearchTerm] = useState("");
//    const [robotData, setRobotData] = useState([]);
//    const [robotList, setRobotList] = useState([]);
//    const [robotID, setRobotID] = useState("");
//    const [robotName, setRobotName] = useState("");
//    const role_id = sessionStorage.getItem("role_id");
//    //*** Create columns for react table
//    const columns = [
//        /*{ name: "ID", selector: (row) => row.robot_id, sortable: true, },*/
//        { name: "ID", selector: (row) => <a className="alink" onClick={() => editRobot(row.robot_id)}>{row.robot_id}</a>, sortable: true, },
//        { name: "Plant", selector: (row) => row.plant_name, sortable: true, },
//        { name: "Robot", selector: (row) => row.robot_name, sortable: true },
//        { name: "Robot Code", selector: (row) => row.robot_code, sortable: true },
//        { name: "Wheel Perimeter", selector: (row) => row.wheel_perimeter, sortable: true },
//        { name: "Sending Topic", selector: (row) => row.mqtt_sending_topic, sortable: true },
//        { name: "Receving Topic", selector: (row) => row.mqtt_receiving_topic, sortable: true },
//        { name: "Low Battery Level", selector: (row) => row.low_battery_level, sortable: true },
//        { name: "Date", selector: (row) => row.robot_added_date, sortable: true },
//        { name: "Delete", selector: (row) => <a className="alink" onClick={() => showModal(row.robot_id, row.robot_name)}>Delete</a>, sortable: true, },
//    ];
//    const showModal = (robot_id, robot_name) => {
//        setRobotID(robot_id);
//        setRobotName(robot_name);
//        var divmodal = document.getElementById("dvmodal");
//        var divMessage = document.getElementById("dvMessage");
//        divmodal.style.display = "block";
//        divMessage.innerText = "are you sure to delete robot ID '" + robot_id + "'?"
//        divmodal.scrollIntoView();
//    };
//    const hideModal = (dvmodal) => {
//        var dvimodal = document.getElementById(dvmodal);
//        dvimodal.style.display = "none";
//    };
//    const deleteRecord = async () => {
//        var user_id = sessionStorage.getItem("user_id");
//        try {
//            let response = await AxiosInstance.get("/PlantRobot/DeleteRobot?rbtid=" + robotID + "&uid=" + user_id + "&pn=DeleteRobot");
//            response.then((res) => {
//                if (res.data) {
//                    hideModal("dvmodal");
//                    fetchRobotData();
//                }
//            })
//            response.catch(
//                function (error) {
//                    console.log('Error Message:' + error)
//                }
//            )
//        }
//        catch (error) {
//            console.log(error);
//        }
//    }
//    //*** Seach Textbox text change event
//    const handleSearch = (event) => {
//        setSearchTerm(event.target.value);
//        let tempList = robotData;
//        const filteredData = tempList.filter((event) =>
//            Object.values(event).some(
//                (value) => typeof value === "string" && value.includes(searchTerm)
//            )
//        );
//        if (event.target.value != null) {
//            setRobotList(filteredData);
//        }
//        if (event.target.value === "") {
//            setRobotList(robotData);
//        }
//    };
//    //*** Filter table
//    const filteredData = robotList.filter((event) =>
//        Object.values(event).some(
//            (value) => typeof value === "string" && value.includes(searchTerm)
//        )
//    );
//    //*** Use React hooks - if any changes on page then useffect() function will run auto
//    useEffect(() => {
//        fetchRobotData();
//    }, [])
//    useEffect(() => {
//        console.log(robotData)
//    }, [robotData])
//    //*** Fetch data from API
//    const fetchRobotData = async () => {
//        var robot_id = 1;//sessionStorage.getItem("editRobotId");
//        var user_id = sessionStorage.getItem("user_id");
//        var _token = sessionStorage.getItem("token");
//        if (_token) _token = "Token exists";
//        try {
//            let response = await Axios("/PlantRobot?rbtid=" + robot_id + "&uid=" + user_id + "&pn=SearchRobot&sn=SearchAllRobot");
//            response.then((res) => {
//                if (res.data) {
//                    setRobotData(response.data)
//                    setRobotList(response.data)
//                }
//            })
//            response.catch(
//                function (error) {
//                    console.log('Error Message:' + error)
//                }
//            )
//        }
//        catch (error) {
//            console.log(error);
//        }

//    }
//    return (
//         <>
//        {hasJWTToken() && (role_id === 1) ? (
//        <div className="page-container">
//         <div className="search-container">
//                <h2 className="form-title"><FaIcons.FaSearch /> Search Robot</h2>
//                <div class="row">
//                    <div class="col-1"></div>
//                    <div class="col-12"><a className="btndelete" href="#/PlantRobot">Add New Robot</a></div>
//                </div>
//             <div>
//                <div
//                    style={{
//                        border: "1px solid #c0c0c0",
//                        borderRadius: "5px",
//                        margin:"2%",
//                        backgroundColor: "#fff",
//                    }}
//                >
//                    <div className="container dvscroll" >
//                        <div className="row dvscroll">
//                            <div className="col-sm-12">
//                                <input
//                                    type="text"
//                                    placeholder="Search Results"
//                                    style={{
//                                        width: "20%",
//                                        height: "30px",
//                                        margin: "10px",
//                                        float: "right",
//                                        border: "none",
//                                        padding: "1.5%",
//                                        borderRadius: "5px",
//                                    }}
//                                    value={searchTerm}
//                                    onChange={handleSearch}
//                                />
//                                <p></p>
//                                <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
//                                    search={true}
//                                    columns={columns}
//                                    data={filteredData}
//                                    highlightOnHover={true}
//                                    customStyles={customStyles}
//                                >
//                                </DataTable>
//                            </div>
//                        </div>
//                        </div>
//                        <div id="dvmodal" class="modalcontainer">
//                            <Modal.Dialog size="lg"
//                                aria-labelledby="contained-modal-title-vcenter"
//                                centered
//                            >
//                                <Modal.Header closeButton onClick={() => hideModal("dvmodal")}>
//                                    <Modal.Title>
//                                        Delete Robots
//                                    </Modal.Title>
//                                </Modal.Header>
//                                <Modal.Body>
//                                    <p>
//                                        <div id="dvMessage"></div>
//                                    </p>
//                                </Modal.Body>
//                                <Modal.Footer>
//                                    <a variant="secondary" className="btndelete" onClick={() => deleteRecord()}>
//                                        Delete
//                                    </a>
//                                    <a variant="secondary" className="btncancel" onClick={() => hideModal("dvmodal")}>
//                                        Cancel
//                                    </a>
//                                </Modal.Footer>
//                            </Modal.Dialog>
//                        </div>
//                </div>
//            </div>
//            </div>
//                </div>
//            ) :
//                (
//                    window.location.href = "#/Login"
//                )
//            }
//        </>
//    );
//}
//export default SearchRobot;


//// ---------------------------------------------
//// Imports
//// ---------------------------------------------
//// React + hooks
//import React, { useEffect, useState } from "react";

//// Data table library for listing robots
//import DataTable from "react-data-table-component";

//// Bootstrap modal for confirmations
//import Modal from "react-bootstrap/Modal";

//// Icons
//import * as FaIcons from "react-icons/fa";

//// Custom Axios instance (handles base URL, token, interceptors, etc.)
//import AxiosInstance from "../Axios/AxiosInstance";

//// Auth guard to check JWT token
//import { hasJWTToken } from "../Account/RouteGuard";

//// Styles
//import "../../Assets/Styles/robot.css";
//import "../../Assets/Styles/Form.css";


//// -------------------------------------------------------
//// Helper — store robot id in session and redirect to edit
//// -------------------------------------------------------
//const editRobot = (robotId) => {
//    sessionStorage.setItem("editRobotId", robotId);
//    window.location.href = `#/edit-robot?rbtid=${robotId}`;
//};


//// -------------------------------------------------------
//// Custom table styles (small UI tuning)
//// -------------------------------------------------------
//const customStyles = {
//    table: { style: { border: "none", fontSize: "100%" } },
//    headRow: { style: { fontSize: "110%" } },
//    headCells: { style: { fontWeight: "700" } }
//};


//// =======================================================
//// MAIN COMPONENT
//// =======================================================
//export const SearchRobot = () => {

//    // ---------------------------------------------
//    // STATE VARIABLES
//    // ---------------------------------------------

//    // Search text
//    const [searchTerm, setSearchTerm] = useState("");

//    // Full robot list (original data)
//    const [robotList, setRobotList] = useState([]);

//    // List currently displayed in table (after filtering)
//    const [filteredList, setFilteredList] = useState([]);

//    // Selected robot ID for delete action
//    const [robotID, setRobotID] = useState(null);

//    // Modal visibility flag
//    const [showDeleteModal, setShowDeleteModal] = useState(false);

//    // Logged-in user role
//    const role_id = sessionStorage.getItem("role_id");


//    // ---------------------------------------------
//    // API CALL: Fetch all robots
//    // ---------------------------------------------
//    const fetchRobotData = async () => {
//        try {
//            const user_id = sessionStorage.getItem("user_id");

//            // API call to fetch robot list
//            const response = await AxiosInstance.get(
//                `/PlantRobot?rbtid=0&uid=${user_id}&pn=SearchRobot&sn=SearchAllRobot`
//            );

//            // Save data in both "master" and "filtered" lists
//            setRobotList(response.data);
//            setFilteredList(response.data);

//        } catch (err) {
//            console.error("Fetch robot error: ", err);
//        }
//    };


//    // ---------------------------------------------
//    // SEARCH: Filter list based on search input
//    // ---------------------------------------------
//    const handleSearch = (e) => {
//        const value = e.target.value;
//        setSearchTerm(value);

//        // If search box is empty → show full list again
//        if (!value) {
//            setFilteredList(robotList);
//            return;
//        }

//        // Case-insensitive filtering across all string fields
//        const filtered = robotList.filter((item) =>
//            Object.values(item).some(
//                (val) =>
//                    typeof val === "string" &&
//                    val.toLowerCase().includes(value.toLowerCase())
//            )
//        );

//        setFilteredList(filtered);
//    };


//    // ---------------------------------------------
//    // OPEN delete confirmation modal
//    // ---------------------------------------------
//    const confirmDelete = (id) => {
//        setRobotID(id);
//        setShowDeleteModal(true);
//    };


//    // ---------------------------------------------
//    // DELETE robot
//    // ---------------------------------------------
//    const deleteRecord = async () => {
//        try {
//            const user_id = sessionStorage.getItem("user_id");

//            await AxiosInstance.get(
//                `/PlantRobot/DeleteRobot?rbtid=${robotID}&uid=${user_id}&pn=DeleteRobot`
//            );

//            // Close modal + refresh table
//            setShowDeleteModal(false);
//            fetchRobotData();

//        } catch (err) {
//            console.error("Delete error:", err);
//        }
//    };


//    // ---------------------------------------------
//    // Fetch robot data on first component load
//    // ---------------------------------------------
//    useEffect(() => {
//        fetchRobotData();
//    }, []);


//    // ---------------------------------------------
//    // Column definitions for data table
//    // ---------------------------------------------
//    const columns = [
//        {
//            name: "ID",
//            selector: (row) => (
//                <a onClick={() => editRobot(row.robot_id)} className="alink">
//                    {row.robot_id}
//                </a>
//            ),
//        },
//        { name: "Plant", selector: (row) => row.plant_name },
//        { name: "Robot", selector: (row) => row.robot_name },
//        { name: "Robot Code", selector: (row) => row.robot_code },
//        { name: "Wheel Perimeter", selector: (row) => row.wheel_perimeter },
//        { name: "Sending Topic", selector: (row) => row.mqtt_sending_topic },
//        { name: "Receiving Topic", selector: (row) => row.mqtt_receiving_topic },
//        { name: "Low Battery Level", selector: (row) => row.low_battery_level },
//        { name: "Date", selector: (row) => row.robot_added_date },

//        // Delete button
//        {
//            name: "Delete",
//            selector: (row) => (
//                <a onClick={() => confirmDelete(row.robot_id)} className="alink">
//                    Delete
//                </a>
//            ),
//        },
//    ];


//    // ---------------------------------------------
//    // If not logged in → redirect to login
//    // ---------------------------------------------
//    if (!hasJWTToken()) {
//        window.location.href = "#/Login";
//        return null;
//    }


//    // ---------------------------------------------
//    // UI Rendering
//    // ---------------------------------------------
//    return (
//        <>
//            {hasJWTToken() ? (

//                <div className="page-container" style={{ backgroundColor:"white"} }>
//                    <p></p> <p></p>
//         {/* Page Title */}
//            <h2 className="form-title">
//                <FaIcons.FaSearch /> Search Robot
//            </h2>

//            {/* Add new robot button */}
//            <a className="btndelete" href="#/plant-robot">
//                &nbsp;&nbsp;Add New Robot
//            </a>

//         {/* Search input */}
//          <div className="container">
//            <input
//                type="text"
//                placeholder="Search Results"
//                value={searchTerm}
//                onChange={handleSearch}
//                style={{
//                         width: "20%",
//                         float: "right",
//                         margin: "10px",
//                         borderRadius: "5px",
//                         padding: "8px",
//                     }}
//            />

//            {/* Data table */}
//            <DataTable
//                columns={columns}
//                data={filteredList}
//                pagination
//                highlightOnHover
//                customStyles={customStyles}
//            />
//         </div>
//            {/* Delete confirmation modal */}
//            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
//                <Modal.Header closeButton>
//                    <Modal.Title>Delete Robot</Modal.Title>
//                </Modal.Header>

//                <Modal.Body>
//                    Are you sure you want to delete robot ID <b>{robotID}</b>?
//                </Modal.Body>

//                <Modal.Footer>
//                    <button className="btndelete" onClick={deleteRecord}>
//                        Delete
//                    </button>

//                    <button className="btncancel" onClick={() => setShowDeleteModal(false)}>
//                        Cancel
//                    </button>
//                </Modal.Footer>
//            </Modal>
//        </div>
//    ) : (
//        (window.location.href = "#/Login")
//    )
//}
//        </>
//    );
//};


//// ---------------------------------------------
//// Export
//// ---------------------------------------------
//export default SearchRobot;

// =======================================================
// SearchRobot.jsx
// Description: List, search, edit and delete Robots
// =======================================================

import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Modal from "react-bootstrap/Modal";
import * as FaIcons from "react-icons/fa";

import AxiosInstance from "../Axios/AxiosInstance";
import { hasJWTToken } from "../Account/RouteGuard";

import "../../Assets/Styles/robot.css";
import "../../Assets/Styles/Form.css";


// -------------------------------------------------------
// Navigate to Edit Robot screen
// -------------------------------------------------------
/**
 * Redirect user to Edit Robot page and store selected robot ID
 * @param {number|string} robotId - Selected robot ID
 */
const editRobot = (robotId) => {
    sessionStorage.setItem("editRobotId", robotId);
    window.location.href = `#/edit-robot?rbtid=${robotId}`;
};


// -------------------------------------------------------
// Custom UI styles used by the DataTable
// -------------------------------------------------------
const customStyles = {
    table: { style: { border: "none", fontSize: "100%" } },
    headRow: { style: { fontSize: "110%" } },
    headCells: { style: { fontWeight: "700" } },
};


// =======================================================
// MAIN COMPONENT
// =======================================================
export const SearchRobot = () => {

    // -----------------------------
    // STATE
    // -----------------------------
    const [searchTerm, setSearchTerm] = useState("");
    const [robotList, setRobotList] = useState([]);       // Complete list
    const [filteredList, setFilteredList] = useState([]); // Search filtered list
    const [robotID, setRobotID] = useState(null);         // Selected robot for delete
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const role_id = sessionStorage.getItem("role_id");


    // ---------------------------------------------------
    // Fetch robot list from backend API
    // ---------------------------------------------------
    /**
     * Loads all robots from backend and populates table
     */
    const fetchRobotData = async () => {
        try {
            const user_id = sessionStorage.getItem("user_id");

            const response = await AxiosInstance.get(
                `/PlantRobot?rbtid=0&uid=${user_id}&pn=SearchRobot&sn=SearchAllRobot`
            );

            setRobotList(response.data);
            setFilteredList(response.data);

        } catch (err) {
            console.error("Fetch robot error:", err);
        }
    };


    // ---------------------------------------------------
    // Handle Search / Filtering
    // ---------------------------------------------------
    /**
     * Filters robot list when user types in search input
     * @param {object} e - Input change event
     */
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        // Reset view when search box is cleared
        if (!value) {
            setFilteredList(robotList);
            return;
        }

        // Case-insensitive match against all string fields
        const filtered = robotList.filter((item) =>
            Object.values(item).some(
                (val) =>
                    typeof val === "string" &&
                    val.toLowerCase().includes(value.toLowerCase())
            )
        );

        setFilteredList(filtered);
    };


    // ---------------------------------------------------
    // Open delete modal
    // ---------------------------------------------------
    /**
     * Show delete confirmation modal
     * @param {number|string} id - Robot ID selected to delete
     */
    const confirmDelete = (id) => {
        setRobotID(id);
        setShowDeleteModal(true);
    };


    // ---------------------------------------------------
    // Delete robot
    // ---------------------------------------------------
    /**
     * Deletes selected robot and refreshes list
     */
    const deleteRecord = async () => {
        try {
            const user_id = sessionStorage.getItem("user_id");

            await AxiosInstance.get(
                `/PlantRobot/DeleteRobot?rbtid=${robotID}&uid=${user_id}&pn=DeleteRobot`
            );

            setShowDeleteModal(false);
            fetchRobotData();

        } catch (err) {
            console.error("Delete error:", err);
        }
    };


    // ---------------------------------------------------
    // Lifecycle – load robots once on mount
    // ---------------------------------------------------
    useEffect(() => {
        fetchRobotData();
    }, []);


    // ---------------------------------------------------
    // Table Columns
    // ---------------------------------------------------
    const columns = [
        {
            name: "ID",
            selector: (row) => (
                <a onClick={() => editRobot(row.robot_id)} className="alink">
                    {row.robot_id}
                </a>
            ),
        },
        { name: "Plant", selector: (row) => row.plant_name },
        { name: "Robot", selector: (row) => row.robot_name },
        { name: "Robot Code", selector: (row) => row.robot_code },
        { name: "Wheel Perimeter", selector: (row) => row.wheel_perimeter },
        { name: "Sending Topic", selector: (row) => row.mqtt_sending_topic },
        { name: "Receiving Topic", selector: (row) => row.mqtt_receiving_topic },
        { name: "Low Battery Level", selector: (row) => row.low_battery_level },
        { name: "Date", selector: (row) => row.robot_added_date },
        {
            name: "Delete",
            selector: (row) => (
                <a onClick={() => confirmDelete(row.robot_id)} className="alink">
                    Delete
                </a>
            ),
        },
    ];


    // ---------------------------------------------------
    // Redirect to login if token missing
    // ---------------------------------------------------
    if (!hasJWTToken()) {
        window.location.href = "#/Login";
        return null;
    }


    // ---------------------------------------------------
    // UI
    // ---------------------------------------------------
    return (
        <>
            {hasJWTToken() ? (
                <div className="page-container" style={{ backgroundColor: "white" }}>
                <p>&nbsp;</p>
                {/*<h2 className="form-title">*/}
                {/*    <FaIcons.FaSearch /> Search Robot*/}
                {/*</h2>*/}

                {/* Add Robot Button */}
                {/*<a className="btndelete" href="#/plant-robot">*/}
                {/*    Add New Robot*/}
                {/*</a>*/}

                {/* Search Input */}
                {/* 
                <div className="container">
                    <input
                        type="text"
                        placeholder="Search Results"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{
                            width: "20%",
                            float: "right",
                            margin: "10px",
                            borderRadius: "5px",
                            padding: "8px",
                        }}
                    />
                </div>
                */}

                <h2 className="form-title">
                    <FaIcons.FaSearch /> Search Robot
                </h2>

                {/* Add Robot + Search (same row) */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px"
                    }}
                >
                    <a className="btndelete" href="#/plant-robot">
                        Add New Robot
                    </a>

                    <input
                        type="text"
                        placeholder="Search Results"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{
                            width: "25%",
                            borderRadius: "5px",
                            padding: "8px",
                            border: "1px solid #ccc"
                        }}
                    />
                </div>

                {/* Data Table */}
                <DataTable
                    columns={columns}
                    data={filteredList}
                    pagination
                    highlightOnHover
                    customStyles={customStyles}
                />
           

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Robot</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to delete Robot ID: <b>{robotID}</b>?
                </Modal.Body>

                <Modal.Footer>
                    <button className="btndelete" onClick={deleteRecord}>
                        Delete
                    </button>

                    <button className="btncancel" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </button>
                </Modal.Footer>
                    </Modal>
           </div>
            ) : (
            (window.location.href = "#/Login")
            )}
        </>
    );
};

export default SearchRobot;
